import { render, staticRenderFns } from "./voice-play.vue?vue&type=template&id=25e153b3&scoped=true&"
import script from "./voice-play.vue?vue&type=script&lang=js&"
export * from "./voice-play.vue?vue&type=script&lang=js&"
import style0 from "./voice-play.vue?vue&type=style&index=0&id=25e153b3&scoped=true&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e153b3",
  null
  
)

export default component.exports